import initProductVariants from './product-variants';
import initQuantityInputs from './quantityInputs';
import initProductChoices from './product-choices';
import initAtcForm from './atcForm';
import { setPopupClose } from '../utils/popupController';
import { SELECTORS, CLASSES } from '../utils/constants';
import getLocalePrefix from '../lib/getLocalePrefix';
import { initSwiper } from './swiper';

const initAtcPopup = () => {
  const atcButtons = document.querySelectorAll('[data-product-card-atc]');
  if (!atcButtons) return;
  const popup = document.querySelector('[data-atc-popup]');
  const popupContent = popup.querySelector('[data-atc-popup-content]');
  const popupCloseBtn = popup.querySelector('[data-atc-popup-close]');
  const popupOverlay = document.querySelector('[data-atc-popup-overlay]');

  const getProductData = async (atcBtn) => {
    const loadingSpinner = atcBtn.querySelector(SELECTORS.LOADING_SPINNER);
    loadingSpinner.classList.remove('hidden');
    const localePrefix = getLocalePrefix();
    try {
      return await fetch(`${location.origin}${localePrefix}/products/${atcBtn.dataset.productCardAtc}?view=atc-popup`);
    } catch (e) {
      console.error('Failed to fetch quick-view product data:', e);
      return null;
    } finally {
      loadingSpinner.classList.add('hidden');
    }
  };

  const renderPopup = async (atcBtn) => {
    const productResponse = await getProductData(atcBtn);
    if (!productResponse) return;
    const htmlText = await productResponse.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlText, 'text/html');
    const productPopupHTML = doc.querySelector('[data-atc-popup-product]');
    if (!productPopupHTML) return;
    popupContent.innerHTML = productPopupHTML.innerHTML;
    requestAnimationFrame(() => {
      initProductVariants(popup);
      initProductChoices(popup);
      initQuantityInputs(popup);
      const gallerySwiperEl = popupContent.querySelector('[data-swiper]');
      if (gallerySwiperEl) initSwiper(gallerySwiperEl);
      if (typeof window.yotpoWidgetsContainer.initWidgets === 'function') {
        window.yotpoWidgetsContainer.initWidgets();
      }
    });
  };

  const setPopupState = (isOpen) => {
    popup.classList.toggle('atc-popup-open', isOpen);
    popup.classList.toggle(CLASSES.TRANSLATE_X_0, isOpen);
    popup.classList.toggle(CLASSES.TRANSLATE_X_100, !isOpen);
  };

  const closePopup = () => {
    setPopupState(false);
    popupContent.innerHTML = '';
    popupCloseBtn.removeEventListener('click', closePopup);
    popupOverlay?.removeEventListener('click', closePopup);
  };
  setPopupClose(closePopup);

  const openPopup = async (atcBtn) => {
    await renderPopup(atcBtn);
    setPopupState(true);
    popupCloseBtn.focus();
    initAtcForm(true);
    popupCloseBtn.addEventListener('click', closePopup);
    popupOverlay?.addEventListener('click', closePopup);
  };

  atcButtons.forEach(atcBtn => {
    atcBtn.addEventListener('click', () => {
      openPopup(atcBtn, atcBtn.hasAttribute('data-atc-quick-order'));
    });
  });
};

export default initAtcPopup;
